// useTripBase — returns "/viaje/:tripId" or "" when no trip context.
import { useParams } from "react-router-dom";

export function useTripBase() {
  const { tripId } = useParams();
  return tripId ? `/viaje/${tripId}` : "";
}
